import service from '../providers/service.js';
import { SET_USERS, DELETE_USER, SET_SELECTED_USER, SET_ONLINE_USERS } from './types.js';
import { tokenize } from "../helpers/token.js";
import { generateUserProfile } from "../helpers/user.js";
import BrowserHistory from '../providers/BrowserHistory.js';
import { setErrors } from "./error.js";
import { setCurrentUser } from "./auth.js";
import { contactSetMyId } from './chat/contactActions.js';

// Fetch user
export function fetchUser(userId, current = false) {
  return (dispatch) => {
    service
      .get(tokenize(`/api/users/${userId}`))
      .then(response => {
        if (current) {
          dispatch(setCurrentUser(generateUserProfile(response, true)));
        } else {
          dispatch(setSelectedUser(generateUserProfile(response)));
        }
      }).catch((err) => {
        console.log(err);
      })
  };
}

// Fetch all users
export function fetchUsers() {
  return dispatch => {
    service
      .get(tokenize(`/api/users`))
      .then(response => {
        dispatch(setUsers(response.data.users));
      }).catch(err => {
        console.log(err);
      })
  }
}

// Update user account
export function updateUser(userId, newProfile, redirect) {
  console.log(newProfile);
  return (dispatch) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(newProfile).forEach(k => {
      if (newProfile[k]) {
        if (newProfile[k].constructor === Array) {
          data.append(k, JSON.stringify(newProfile[k]));
        } else {
          data.append(k, newProfile[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/users/${userId}`), data, config)
      .then(response => {
        if (response.data.message === 'user.success') {
          if (redirect) {
            BrowserHistory.push('/main/user-management');
          } else {
            dispatch(fetchUser(userId, true));
          }
          alert("Profile has been updated successfully!");
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch((err) => {
        console.log(err);
        alert("An error has occured!");
      })
  };
}

// Create new account
export function createUser(account) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(account).forEach(k => {
      if (account[k]) {
        if (account[k].constructor === Array) {
          data.append(k, JSON.stringify(account[k]));
        } else {
          data.append(k, account[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/users`), data, config)
      .then(response => {
        if (response.data.message === 'user.success') {
          BrowserHistory.push('/main/user-management');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Delete user
export function deleteUser(userId) {
  return dispatch => {
    service
      .post(tokenize(`/api/users/${userId}/destroy`))
      .then(response => {
        if (response.data.message === 'user.success') {
          dispatch(deleteUserFromStore(userId))
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err)
      });
  }
}

export function deleteUserFromStore(userId) {
  return {
    type: DELETE_USER,
    userId: userId
  }
}

// set users to redux store
export function setUsers(users) {
  return {
    type: SET_USERS,
    users: users
  }
}

// Set selected user in redux store
export function setSelectedUser(user) {
  return {
    type: SET_SELECTED_USER,
    user: user
  };
}

/**
 * Set online status to user with id userId
 * @param {array} userIds 
 */
export function setOnlineUsers(userIds) {
  return {
    type: SET_ONLINE_USERS,
    users: userIds
  };
}


// WEBPACK FOOTER //
// ./src/actions/user.js